module.exports = __webpack_public_path__ + "static/012-2f24832e276b4c5817cb59633a83a16e.jpg";